import Header from "@/components/site/Header";
import NotificationBanner from "@/components/site/NotificationBanner";
import Hero from "@/components/site/Hero";
import Menu from "@/components/site/Menu";
import Reviews from "@/components/site/Reviews";
import Gallery from "@/components/site/Gallery";
import About from "@/components/site/About";
import LocationHours from "@/components/site/LocationHours";
import Footer from "@/components/site/Footer";
import CartDrawer from "@/components/site/CartDrawer";
import DiscountPopup from "@/components/site/DiscountPopup";
import FloatingActions from "@/components/site/FloatingActions";
import PWAInstallPrompt from "@/components/site/PWAInstallPrompt";

export default function Landing() {
    return (
        <div className="bg-background text-foreground">
            <NotificationBanner />
            <Header />
            <main>
                <Hero />
                <Menu />
                <Reviews />
                <Gallery />
                <About />
                <LocationHours />
            </main>
            <Footer />
            <CartDrawer />
            <DiscountPopup />
            <FloatingActions />
            <PWAInstallPrompt />
        </div>
    );
}
